export const SET_DATA = 'SET_COMPONENT_DATA'

export const setComponentData = (payload: any) => ({
  type: SET_DATA,
  payload,
})
